import __ from "../../../../../../core/utils/translate/translate";

export const steps = [
    {icon: "team-create", title: __("Make a team")},
    {icon: "team-not-freeze", title: __("Recruiting")},
    {icon: "team-freeze", title: __("Close team")},
];
